import React, { createContext } from 'react';
import { CORE_PROJECT } from '@atlassian/jira-common-constants/src/project-types';
import { defaultLocale } from '@atlassian/jira-common-constants/src/supported-locales';
import { UNLICENSED } from '@atlassian/jira-shared-types/src/edition.tsx';
import { toCloudName } from '@atlassian/jira-shared-types/src/general.tsx';
import type { AccessPageContext } from '../../common/types';
import type { Props } from './types';

export const defaultContextValue: AccessPageContext = {
	accountId: '',
	appEdition: UNLICENSED,
	baseUrl: '',
	cloudName: toCloudName(''),
	isAdmin: false,
	isProjectSimplified: false,
	isSiteAdmin: false,
	locale: defaultLocale,
	projectId: -1,
	projectKey: '',
	projectName: '',
	projectType: CORE_PROJECT,
};

const MainProviderContext = createContext<AccessPageContext>(defaultContextValue);

export const AccessPageProvider = (props: Props) => {
	const { context, children } = props;
	return <MainProviderContext.Provider value={context}>{children}</MainProviderContext.Provider>;
};

export const AccessPageConsumer = MainProviderContext.Consumer;

export default MainProviderContext;
